// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"893a932d","453":"a87e3742","796":"5d7745ba"}[chunkId] + ".chunk.js";
};